import { render, staticRenderFns } from "./Dogg.vue?vue&type=template&id=e8e11cf6&scoped=true&"
import script from "./Dogg.vue?vue&type=script&lang=js&"
export * from "./Dogg.vue?vue&type=script&lang=js&"
import style0 from "./Dogg.vue?vue&type=style&index=0&id=e8e11cf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8e11cf6",
  null
  
)

export default component.exports